import confirm from '../../../utils/confirm.jsx';

export function request(bannerId) {
    return {
        type: 'GET_BANNER_CONFIG_REQUEST',
        bannerId
    };
}

export function error(errors) {
    return {
        type: 'GET_BANNER_CONFIG_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'GET_BANNER_CONFIG_FINISH',
        data
    };
}
